import { supabase } from "./supabase";

/**
 * Take a signed sale back (ADR 0326): the database voids the signed
 * documents, clears the signed date, starts the deposit fresh, unticks
 * Signed Contract and puts the job back to Proposal Sent, or refuses with a
 * sentence to show (Sends pressed, money paid, no reason given).
 *
 * The deposit invoice already raised at Mercury is cancelled from here,
 * because the database cannot call an API. Not awaited and never fatal, the
 * same as `voidProposal`: the unwind has landed, and a Mercury refusal is
 * noted on the request row.
 */
export async function unwindSale(jobId: string, reason: string): Promise<void> {
  const { error } = await supabase.rpc("unwind_sale", {
    p_job: jobId,
    p_reason: reason,
  });
  if (error) throw new Error(error.message);
  void supabase.functions
    .invoke("mercury", { body: { action: "withdraw", jobId } })
    .catch(() => {});
}
